import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { numberFromStringSchema } from 'src/Configuration/validation/rules'
import { boolean, object, ObjectSchema, string } from 'yup'
import { StorageInstallationStatementValidationData } from '../../models/storage'
import { ApplicationArea, ConnectionType, InstallationType, NetConfiguration, WeatherCondition } from '../../types'

const TEMPERATURE_NUMBER = 50
const TOP_DISTANCE = 5
const FRONT_DISTANCE = 10
const LEFT_RIGHT_DISTANCE = 15
/**
 * This hook provides the validation schema for storages using the custom defined yup-validation-rules
 */
const useStorageValidation = (): {
  inProgressValidationSchema: ObjectSchema<Partial<StorageInstallationStatementValidationData>>
  finalValidationSchema: ObjectSchema<StorageInstallationStatementValidationData>
} => {
  const { t } = useCustomTranslation()
  const numberFromStringSchemaWithTranslation = numberFromStringSchema(t)

  const inProgressValidationSchema = object().shape({
    connectionType: string<ConnectionType>().nullable(),
    weatherConditions: string<WeatherCondition>().nullable(),
    temperature: numberFromStringSchemaWithTranslation({ min: -TEMPERATURE_NUMBER, max: TEMPERATURE_NUMBER, positive: false }).nullable(),
    netConfiguration: string<NetConfiguration>().nullable(),
    wallMounted: boolean().nullable(),
    installationType: string<InstallationType>().nullable(),
    applicationArea: string<ApplicationArea>().nullable(),
    emergencyOption: boolean().nullable(),
    distanceTop: numberFromStringSchemaWithTranslation({ min: TOP_DISTANCE }).nullable(),
    distanceFront: numberFromStringSchemaWithTranslation({ min: FRONT_DISTANCE }).nullable(),
    distanceLeft: numberFromStringSchemaWithTranslation({ min: LEFT_RIGHT_DISTANCE }).nullable(),
    distanceRight: numberFromStringSchemaWithTranslation({ min: LEFT_RIGHT_DISTANCE }).nullable(),
  })

  const finalValidationSchema: ObjectSchema<StorageInstallationStatementValidationData> = object().shape({
    connectionType: string<ConnectionType>().required(),
    weatherConditions: string<WeatherCondition>().required(),
    temperature: numberFromStringSchemaWithTranslation({ min: -TEMPERATURE_NUMBER, max: TEMPERATURE_NUMBER, positive: false }).required(),
    netConfiguration: string<NetConfiguration>().required(),
    wallMounted: boolean().required(),
    installationType: string<InstallationType>().required(),
    applicationArea: string<ApplicationArea>().required(),
    emergencyOption: boolean().required(),
    distanceTop: numberFromStringSchemaWithTranslation({ min: TOP_DISTANCE }).required(),
    distanceFront: numberFromStringSchemaWithTranslation({ min: FRONT_DISTANCE }).required(),
    distanceLeft: numberFromStringSchemaWithTranslation({ min: LEFT_RIGHT_DISTANCE }).required(),
    distanceRight: numberFromStringSchemaWithTranslation({ min: LEFT_RIGHT_DISTANCE }).required(),
  })

  return { inProgressValidationSchema, finalValidationSchema }
}

export default useStorageValidation
